import { NOTES_TYPES } from "./notesTypes";

const { LOAD_NOTES, SET_NOTES, HANDLE_NOTES_BUILDINGS_INPUTS, CLEAR_NOTES } = NOTES_TYPES;

const initialState = {
  isLoadingPage: false,
  notes: [],
  station: null,
};

export const notesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_NOTES_BUILDINGS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_NOTES:
      return {
        ...state
      };

    case CLEAR_NOTES:
      return {
        ...state,
        ...initialState
      };

    case SET_NOTES:
      return {
        ...state,
        notes: payload.notes
      };

    default:
      return state;
  }
};
